import { ModuleNames, ModuleUrls } from './userConstants';
import { ModuleIds, PermissionIds } from './moduleIds';

// Define permissions for each module
export const ENO1_PERMISSIONS = {
  ACCESS: 'Access to the eNO1 module',
  VIEW_SAMPLES: 'eNO1 View Samples',
  EDIT_SAMPLES: 'eNO1 Edit Samples',
  DELETE_FILES: 'Delete eNO1 Files',
  UPLOAD: 'eNO1 Upload',
  STATUS: 'eNO1 Status',
  NO2_REPORT: 'NO2 Report',
  NO3_REPORT: 'NO3 Report',
  NO3_SIGNED_FORMS: 'NO3 Signed Forms',
  ACCURACY_REPORT: 'Accuracy Report',
  E55_COMPARISON: 'e55 Comparison',
  PLAYGROUND: 'eNO1 Playground'
} as const;

export const E53_PERMISSIONS = {
  ACCESS: 'Access to the e53 sampling module',
  VIEW_SAMPLES: 'e53 View Samples',
  EDIT_SAMPLES: 'e53 Edit Samples',
  DELETE_FILES: 'Delete e53 files',
  UPLOAD: 'e53 Upload',
  STATUS: 'View e53 status',
  CN54_REPORT: 'CN54 Report'
} as const;

export const SAMPLING_PLANNING_PERMISSIONS = {
  ACCESS: 'Access to the Sampling Planning module'
} as const;

export const E55_PERMISSIONS = {
  VIEW_DESPATCHES: 'View Despatches (e55)',
  EDIT_DESPATCHES: 'Edit Despatches (e55)',
  DELETE_FILES: 'Delete e55 Files',
  UPLOAD: 'e55 Upload',
  STATUS: 'e55 Status',
  CN56_REPORT: 'CN56 Report',
  ITEMS_KG_REPORT: 'e55 items-kg report'
} as const;

export const E09_PERMISSIONS = {
  VIEW_DESPATCHES: 'View Despatches (e09)',
  EDIT_DESPATCHES: 'Edit Despatches (e09)',
  DELETE_FILES: 'Delete e09 Files',
  UPLOAD: 'e09 Upload',
  STATUS: 'e09 Status',
  CN10_REPORT: 'CN10 Report',
  CN19_REPORT: 'CN19 Report'
} as const;

export const IPC_TD_ACCOUNTING_PERMISSIONS = {
  ACCESS: 'Access to IPC Accounting module',
  REMUNERATION_GROUPS: 'Remuneration Groups'
} as const;

export const TD_ACCOUNTING_PERMISSIONS = {
  ACCESS: 'Access to the UPU TD Accounting module'
} as const;

// Permission URLs mapping
export const PermissionUrls = {
  // eNO1 Sampling
  [ENO1_PERMISSIONS.ACCESS]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}`,
  [ENO1_PERMISSIONS.VIEW_SAMPLES]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/samples`,
  [ENO1_PERMISSIONS.EDIT_SAMPLES]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/samples/edit`,
  [ENO1_PERMISSIONS.DELETE_FILES]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/files/delete`,
  [ENO1_PERMISSIONS.UPLOAD]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/upload`,
  [ENO1_PERMISSIONS.STATUS]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/status`,
  [ENO1_PERMISSIONS.NO2_REPORT]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/reports/no2`,
  [ENO1_PERMISSIONS.NO3_REPORT]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/reports/no3`,
  [ENO1_PERMISSIONS.NO3_SIGNED_FORMS]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/reports/no3/signed`,
  [ENO1_PERMISSIONS.ACCURACY_REPORT]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/reports/accuracy`,
  [ENO1_PERMISSIONS.E55_COMPARISON]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/reports/e55-comparison`,
  [ENO1_PERMISSIONS.PLAYGROUND]: `${ModuleUrls[ModuleNames.ENO1_SAMPLING]}/playground`,

  // e53 Sampling
  [E53_PERMISSIONS.ACCESS]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}`,
  [E53_PERMISSIONS.VIEW_SAMPLES]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/samples`,
  [E53_PERMISSIONS.EDIT_SAMPLES]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/samples/edit`,
  [E53_PERMISSIONS.DELETE_FILES]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/files/delete`,
  [E53_PERMISSIONS.UPLOAD]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/upload`,
  [E53_PERMISSIONS.STATUS]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/status`,
  [E53_PERMISSIONS.CN54_REPORT]: `${ModuleUrls[ModuleNames.E53_SAMPLING]}/reports/cn54`,

  // Sampling Planning
  [SAMPLING_PLANNING_PERMISSIONS.ACCESS]: `${ModuleUrls[ModuleNames.SAMPLING_PLANNING]}`,

  // e55 Weights
  [E55_PERMISSIONS.VIEW_DESPATCHES]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/despatches`,
  [E55_PERMISSIONS.EDIT_DESPATCHES]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/despatches/edit`,
  [E55_PERMISSIONS.DELETE_FILES]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/files/delete`,
  [E55_PERMISSIONS.UPLOAD]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/upload`,
  [E55_PERMISSIONS.STATUS]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/status`,
  [E55_PERMISSIONS.CN56_REPORT]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/reports/cn56`,
  [E55_PERMISSIONS.ITEMS_KG_REPORT]: `${ModuleUrls[ModuleNames.E55_WEIGHTS]}/reports/items-kg`,

  // e09 IBRS
  [E09_PERMISSIONS.VIEW_DESPATCHES]: `${ModuleUrls[ModuleNames.E09_IBRS]}/despatches`,
  [E09_PERMISSIONS.EDIT_DESPATCHES]: `${ModuleUrls[ModuleNames.E09_IBRS]}/despatches/edit`,
  [E09_PERMISSIONS.DELETE_FILES]: `${ModuleUrls[ModuleNames.E09_IBRS]}/files/delete`,
  [E09_PERMISSIONS.UPLOAD]: `${ModuleUrls[ModuleNames.E09_IBRS]}/upload`,
  [E09_PERMISSIONS.STATUS]: `${ModuleUrls[ModuleNames.E09_IBRS]}/status`,
  [E09_PERMISSIONS.CN10_REPORT]: `${ModuleUrls[ModuleNames.E09_IBRS]}/reports/cn10`,
  [E09_PERMISSIONS.CN19_REPORT]: `${ModuleUrls[ModuleNames.E09_IBRS]}/reports/cn19`,

  // IPC TD Accounting
  [IPC_TD_ACCOUNTING_PERMISSIONS.ACCESS]: `${ModuleUrls[ModuleNames.IPC_TD_ACCOUNTING]}`,
  [IPC_TD_ACCOUNTING_PERMISSIONS.REMUNERATION_GROUPS]: `${ModuleUrls[ModuleNames.IPC_TD_ACCOUNTING]}/remuneration-groups`,

  // TD Accounting
  [TD_ACCOUNTING_PERMISSIONS.ACCESS]: `${ModuleUrls[ModuleNames.TD_ACCOUNTING]}`,
} as const;

// Group all module permissions for easier access
export const ModulePermissions = {
  [ModuleNames.ENO1_SAMPLING]: Object.values(ENO1_PERMISSIONS),
  [ModuleNames.E53_SAMPLING]: Object.values(E53_PERMISSIONS),
  [ModuleNames.SAMPLING_PLANNING]: Object.values(SAMPLING_PLANNING_PERMISSIONS),
  [ModuleNames.E55_WEIGHTS]: Object.values(E55_PERMISSIONS),
  [ModuleNames.E09_IBRS]: Object.values(E09_PERMISSIONS),
  [ModuleNames.IPC_TD_ACCOUNTING]: Object.values(IPC_TD_ACCOUNTING_PERMISSIONS),
  [ModuleNames.TD_ACCOUNTING]: Object.values(TD_ACCOUNTING_PERMISSIONS),
} as const;

// Export all permission constants in a grouped manner
export const PermissionConstants = {
  ENO1: ENO1_PERMISSIONS,
  E53: E53_PERMISSIONS,
  SAMPLING_PLANNING: SAMPLING_PLANNING_PERMISSIONS,
  E55: E55_PERMISSIONS,
  E09: E09_PERMISSIONS,
  IPC_TD_ACCOUNTING: IPC_TD_ACCOUNTING_PERMISSIONS,
  TD_ACCOUNTING: TD_ACCOUNTING_PERMISSIONS,
  ModulePermissions,
  PermissionUrls,
  ModuleIds,
  PermissionIds
};

export default PermissionConstants; 